<template>
    <CardLayout>
        <div class="card-info">
            <div
                v-for="infoItem in infoData"
                :key="getInfoItemValueByKey(infoItem, 'id')"
                class="card-info__item"
            >
                <div class="card-info__item-title">
                    {{ getInfoItemValueByKey(infoItem, 'title') }}
                </div>

                <div class="card-info__item-value">
                    {{ getInfoItemValueByKey(infoItem, 'value') }}
                </div>
            </div>
        </div>
    </CardLayout>
</template>

<script>
import CardLayout from "./Layout";

export default {
    name: 'CardInfo',
    components: { CardLayout },
    props: {
        infoData: {
            type: Array,
            default: () => ([]) 
        }
    },
    methods: {
        getInfoItemValueByKey(infoItem = {}, key = '') {
            return infoItem[key] ?? '';
        }
    }
}
</script>

<style lang="scss" scoped>
$assistant-color: #ADB0BB !default;

.card-info {
    display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;

    &__item {
        &:not(:last-child) {
            margin-bottom: 5px;
        }
        &-title {
            color: $assistant-color;
            font-size: 10px;
        }

        &-value {
            font-weight: 700;
            font-size: 12px;
            margin-top: 5px;
        }
    }
}
</style>